import Script from "next/script"

/**
 * Check if Didomi is enabled for the environment.
 */
export const isEnabled = () => {
  return process.env.NEXT_PUBLIC_DIDOMI_ENABLED == "true"
}

/**
 * Didomi setup component. It exposes the `window.didomiOnReady` global object so we can safely invoke it
 * even if the environment does not have Didomi enabled.
 */
export const Didomi = () => {
  if (!isEnabled()) {
    return (
      <Script
        data-testid="didomi-snippet"
        id="didomi-snippet"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.didomiOnReady = window.didomiOnReady || [];
          `,
        }}
      />
    )
  }

  /**
   * The following Didomi SDK code snippet was generated with these options:
   *
   *  - Which domain do you want to use to load the SDK?
   *    Use a Didomi domain (default)
   *
   *  - How do you want to load the consent notice?
   *    Based on domain
   *
   * These settings unfortunately do not save when you publish a new notice version, so be
   * cautious when upgrading that you generate the right snippet.
   *
   * Also note that the API key is public, and shared between all environments. The domain
   * of the application (eg. theconversation.com) determines which notice appears for users.
   *
   * The following that you will see below is NOT part of the snippet and must be retained:
   *      window.didomiOnReady = window.didomiOnReady || [];
   *      window.didomiEventListeners = window.didomiEventListeners || [];
   *      (**SNIPPET HERE**)
   **/
  return (
    <Script
      data-testid="didomi-snippet"
      id="didomi-snippet"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
          window.didomiOnReady = window.didomiOnReady || [];
          window.didomiEventListeners = window.didomiEventListeners || [];
          (function(){(function(e,i){var o=document.createElement("link");o.rel="preconnect";o.as="script";var n=document.createElement("link");n.rel="dns-prefetch";n.as="script";var r=document.createElement("script");r.id="spcloader";r.type="text/javascript";r["async"]=true;r.charset="utf-8";window.didomiConfig=window.didomiConfig||{};window.didomiConfig.sdkPath=window.didomiConfig.sdkPath||i||"https://sdk.privacy-center.org/";const t=window.didomiConfig.sdkPath;var d=t+e+"/loader.js?target="+document.location.hostname;if(window.didomiConfig&&window.didomiConfig.user){var a=window.didomiConfig.user;var c=a.country;var s=a.region;if(c){d=d+"&country="+c;if(s){d=d+"&region="+s}}}var dL=(navigator.languages&&navigator.languages[0])||navigator.language||navigator.userLanguage;if(dL){d=d+"&lang="+encodeURIComponent(dL)}o.href=t;n.href=t;r.src=d;var f=document.getElementsByTagName("script")[0];f.parentNode.insertBefore(o,f);f.parentNode.insertBefore(n,f);f.parentNode.insertBefore(r,f)})("a1179046-1792-42d9-812f-3daba6c97289")})();
        `,
      }}
    />
  )
}
